export default "__VITE_ASSET__cMqdXs_4__"